import { z } from 'zod';

// Ročný finančný súhrn — dekódované kľúčové metriky z RÚZ (Blok 3, Týž. 11).
export const financialSummaryYearSchema = z.object({
  period: z.number(),
  totalAssets: z.number().nullable(),
  equity: z.number().nullable(),
  liabilities: z.number().nullable(),
  netIncome: z.number().nullable(),
  revenue: z.number().nullable(),
  // Týž. 19+ — dopočítané z už dekódovaných RÚZ riadkov, viď financial-summary.service.ts.
  // Altman Z' oprava (2026-07-20): `ebit` = skutočné EBIT (EBT + nákladové úroky),
  // `operatingResult` = predtým jediný `ebit` (výsledok hosp. z hosp. činnosti,
  // stále používaný pre EBITDA a prevádzkovú maržu — FinStat parita).
  ebit: z.number().nullable(),
  operatingResult: z.number().nullable(),
  ebitda: z.number().nullable(),
  roa: z.number().nullable(),
  // Týž. 20+ — čistý pracovný kapitál (obežný majetok − krátkodobé záväzky). Bolo už
  // vracané z API, ale chýbalo v tejto shared schéme (nekonzistencia opravená
  // Corpuls redizajnom 2026-07-15).
  workingCapital: z.number().nullable(),
  currentAssets: z.number().nullable(),
  // Corpuls redizajn (2026-07-15) — rozšírené finančné ukazovatele, viď
  // /root/.claude/plans/abstract-finding-unicorn.md a financial-ratios.ts. Presné
  // RÚZ riadky overené priamou DB inšpekciou dominantných šablón (687, 699).
  inventory: z.number().nullable(),
  shortTermReceivables: z.number().nullable(),
  tradeReceivables: z.number().nullable(),
  financialAssets: z.number().nullable(),
  shortTermLiabilities: z.number().nullable(),
  tradePayables: z.number().nullable(),
  // POZOR: úzko definované — len náklady na tovar na ďalší predaj, nie
  // plnohodnotné COGS. Zmysluplné len pre firmy s tržbami z predaja tovaru,
  // viď financial-ratios.ts hrubá marža caveat.
  cogs: z.number().nullable(),
  // Altman Z' oprava (2026-07-20): širšie COGS (tovar+materiál/energie+služby),
  // pre obrat zásob/DPO — viď RuzTemplateClient.getCostOfRevenue.
  costOfRevenue: z.number().nullable(),
  interestExpense: z.number().nullable(),
  // Výsledok hospodárenia minulých rokov — pre Altman Z" X2 zložku (bola už
  // dekódovaná pre AltmanZScoreService, len nebola vystavená v ročnom súhrne).
  retainedEarnings: z.number().nullable(),
  // 2026-07-23 — plný rozpis súvahy, viď financial-summary.service.ts komentár.
  nonCurrentAssets: z.number().nullable(),
  intangibleAssets: z.number().nullable(),
  tangibleAssets: z.number().nullable(),
  longTermFinancialAssets: z.number().nullable(),
  shareCapital: z.number().nullable(),
  // 2026-07-24 — úročený dlh (bankové úvery) oddelene od celkových záväzkov,
  // a osobné náklady/mzdy — viď financial-summary.service.ts komentár.
  longTermBankLoans: z.number().nullable(),
  currentBankLoans: z.number().nullable(),
  shortTermFinancialAssistance: z.number().nullable(),
  bankLoansTotal: z.number().nullable(),
  personnelCosts: z.number().nullable(),
  wageCosts: z.number().nullable(),
});
export type FinancialSummaryYear = z.infer<typeof financialSummaryYearSchema>;
